export type ISetPermissionsMap = ReturnType<typeof setPermissionsMap>;
export const setPermissionsMap = (map: { [key: string]: string[] }) => ({
  type: 'authorisation/setPermissionsMap' as const,
  payload: {
    map,
  },
});
